import { useTheme, useMediaQuery } from '@mui/material';
import ContribuentiListPageDesktop from './ContribuentiListPageDesktop';
import ContribuentiListPageMobile from './ContribuentiListPageMobile';

export default function ContribuentiListPage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return isMobile
    ? <ContribuentiListPageMobile />
    : <ContribuentiListPageDesktop />;
}